import { CampaignType } from 'generated-graphql/types';

export const getShouldCheckIfCandidatesAlreadyApplied = (
  campaignType: CampaignType | undefined,
  isFromAnalysisAutomation: boolean,
  hasATSJob: boolean
): boolean => {
  if (campaignType === CampaignType.EngagementOutreach) {
    return false;
  }

  if (isFromAnalysisAutomation) {
    return true;
  }

  if (!hasATSJob) {
    return true;
  }

  return false;
};
